import { useEffect } from "react";
import { LandingFooter, LandingHeader } from "@/components/landing/LandingChrome";
import { Partenaires } from "@/components/landing/Sections";
import { ProDetails } from "@/components/landing/ProDetails";

export default function Professionals() {
  useEffect(() => { window.scrollTo(0, 0); document.title = "CASHMY pour les professionnels — Devenir partenaire"; }, []);
  return (
    <div className="min-h-screen bg-background" data-testid="professionals-page">
      <LandingHeader />
      <main><Partenaires /><ProDetails /></main>
      <LandingFooter />
    </div>
  );
}
